import React from "react";
import { graphql } from "gatsby";
import {
  LinkButton,
  LinkButtonProps,
} from "@zempler/theme/src/components/buttons/linkButton/LinkButton";

interface ButtonBarLinkDataProps {
  data: LinkButtonProps;
  [key: string]: any;
}

export const ButtonBarLink: React.FC<ButtonBarLinkDataProps> = ({
  data,
  dataLayerClickContext,
}) => {
  return (
    <LinkButton
      buttonVariant={data.style?.toLowerCase()?.replace("blue", "zemplerBlue")}
      icon={data.icon}
      link={data.link}
      dataLayerClickContext={dataLayerClickContext}
    />
  );
};

export const ButtonBarLinkQuery = graphql`
  fragment ButtonBarLink on UMBRACO_ButtonBarLinkComponentType {
    style
    icon
    link {
      ...Link
    }
  }
`;
